import styled from 'styled-components';
import { Label } from '../../../Components/uielements';

export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
  min-width: 500px;
  max-width: 600px;
  border-radius: 16px;
  color: white;
  position: relative;
  overflow: hidden;
  max-height: 500px;
  overflow-y: auto;

  @media (max-width: 768px) {
    min-width: 320px;
    max-width: 90vw;
  }

  /* Custom scrollbar */
  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 3px;
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 3px;
  }
`;

export const ModalTitleContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 24px;
  font-weight: 600;
  color: #e6b471;
  padding: 24px 24px 8px 24px;
  margin: 0;
`;

export const UpdateDescription = styled(Label)`
  font-size: 16px;
  line-height: 1.5;
  padding: 0 24px;
`;

export const OptionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px;
  margin: 16px 20px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
`;

export const OptionItem = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const FeatureIcon = styled.div`
  font-size: 24px;
  margin-right: 16px;
  margin-top: 2px;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(122, 234, 167, 0.1);
  border-radius: 8px;

  @media (max-width: 768px) {
    font-size: 20px;
    width: 28px;
    height: 28px;
    margin-right: 12px;
  }
`;

export const FeatureContent = styled.div`
  display: flex;
  align-items: flex-start;
  flex: 1;
`;

export const FeatureDetails = styled.div`
  flex: 1;
`;

export const FeatureTitle = styled(Label)`
  font-size: 16px;
  font-weight: 600;
  color: white;
  margin-bottom: 4px;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 15px;
  }
`;

export const FeatureDescription = styled.div`
  font-size: 14px;
  color: #a8b3cf;
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

export const GotItButton = styled.button`
  background: linear-gradient(135deg, #e6b471 0%, #e6b471 100%);
  color: #1a1b2e;
  border: none;
  border-radius: 12px;
  padding: 16px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  margin: 0 24px;
  margin-bottom: 24px;
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #e6b471 0%, #e6b471 100%);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    padding: 14px 20px;
    font-size: 15px;
  }
`;
